import { getFieldSetting as getCustomFieldSetting } from '@tribeplatform/react-components/CustomField'
import { useI18n } from '@tribeplatform/react-components/i18n'
import type { ViewField } from '@tribeplatform/react-components/Views'

import { useCustomFields } from './useCustomFields.js'

interface BannerSource {
  value: ViewField['settings']['bannerSource']
  text: string
}
export const useBannerSources = (postTypeSlugs: string[]): BannerSource[] => {
  const { $t } = useI18n()
  const { customFields } = useCustomFields({ postTypeSlugs })
  const imageFields =
    customFields
      ?.filter(field => {
        const subtype = getCustomFieldSetting(field, 'subtype')

        return subtype === 'image' || subtype === 'images'
      })
      ?.map(field => ({ value: field.key, text: field.name })) ?? []

  return [
    {
      value: 'post',
      text: $t({
        defaultMessage: 'Post photo',
        id: 'PostsBlock.BannerSources.Post',
      }),
    },
    {
      value: 'seo',
      text: $t({
        defaultMessage: 'SEO image',
        id: 'PostsBlock.BannerSources.SEO',
      }),
    },
    ...imageFields,
  ]
}
